import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import * as Notify from "@repoflow/form-schema/notify";
import { CancellableContent } from "@repoflow/components/content-cancel";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import * as SiteFileQL from "queries/site-file";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>Remove</BreadcrumbItem>
  </>
);

export const Content = ({
  history,
  match: {
    params: { siteId, kind, fileId },
  },
}) => {
  // `parent` is the KIND's provider, so its base is the listing — not this
  // file's own screen, which is about to stop existing. The chain is
  // files › kind › file, and Section.Query does not add a level of its own.
  const {
    values,
    parent: { base },
  } = useSectionContext();

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            Removing the file <b>{values.name || fileId}</b>? This action will
            be permanent and can't be undone.
          </Col>
        </Row>
        <Mutation
          mutation={SiteFileQL.remove}
          update={SiteFileQL.update()}
          onMutate={({ handler }) => {
            handler({
              variables: { siteId, kind, fileId },
            });
          }}
          onCompleted={() => {
            history.replace(base);
          }}
          onError={(error) => {
            Notify.error(error.toString());
          }}
        >
          {MutationHandler}
        </Mutation>
      </Container>
    </CancellableContent>
  );
};

const MutationHandler = ({ mutate }) => {
  return (
    <Row>
      <Col>
        <Button
          onClick={() => {
            mutate();
          }}
        >
          Remove
        </Button>
      </Col>
    </Row>
  );
};
